import { icons } from "assets/mobile";

export const MenuSidebar = [
  { title: "BRAND PARTNERS", link: "", icon: icons.BrandPartner },
  { title: "DOWNLOAD", link: "", icon: icons.DownloadApp },
  { title: "TELEGRAM", link: "", icon: icons.Telegram },
  { title: "AGENT REGISTRATION", link: "", icon: icons.AgencyRegistration },
  { title: "AGENT COMMISSION", link: "", icon: icons.AgencyCommission },
  { title: "BEAUTIFUL GIRLS PICTURE", link: "", icon: icons.BeautifulGirl },
  { title: "INTRODUCING JokerMillion", link: "", icon: icons.Introduction },
  { title: "COMPUTER INTERFACE", link: "", icon: icons.Desktop },
];
